import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Subtitle = styled(Typography)({
  color: 'white',
  fontSize: '16px',
  fontFamily: 'Open Sans !important',
  fontWeight: 400,
  wordWrap: 'break-word',
});

export default Subtitle;
